import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Footer } from "@/components/landing/Footer";
import { WaveIcon } from "@/components/landing/Decorations";

export default function NotAvailablePage() {
    const [search] = useSearchParams();
    const item = (search.get("item") || "this page").replace(/-/g, " ");

    return (
        <div className="min-h-screen bg-cream-100 text-ink">
            <header className="border-b border-cream-300 bg-white/80 backdrop-blur">
                <div className="mx-auto max-w-[1080px] px-5 sm:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2.5">
                        <WaveIcon color="#FF5B3E" className="w-6 h-4"/>
                        <span className="font-display text-[22px] font-semibold tracking-tight">Audo</span>
                    </Link>
                    <Link to="/" className="text-[13px] text-ink-muted hover:text-coral transition-colors">Back to home</Link>
                </div>
            </header>

            <main className="mx-auto max-w-[900px] px-5 sm:px-8 py-16 sm:py-20">
                <div className="bg-white border border-cream-300 rounded-3xl p-8 sm:p-12 text-center shadow-soft">
                    <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-coral mb-3">Coming soon</p>
                    <h1 className="font-display text-[38px] sm:text-[52px] leading-[1.05] font-semibold tracking-tight mb-3">Not available right now</h1>
                    <p className="text-[14px] text-ink-muted mb-8">The page for {item} is not available right now. Please check back later.</p>
                    <div className="flex items-center justify-center gap-3">
                        <Link to="/" className="bg-ink text-cream-100 rounded-full px-5 py-2.5 text-[13px] font-semibold hover:bg-coral transition-colors">Go to home</Link>
                        <Link to="/support" className="border border-cream-300 rounded-full px-5 py-2.5 text-[13px] font-semibold hover:bg-cream-100 transition-colors">Contact support</Link>
                    </div>
                </div>
            </main>

            <Footer/>
        </div>
    );
}
